import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import fordStylesOverride from "./ReportPreviewStylesOverride";
import lincolnStylesOverride from "./ReportPreviewLincolnStylesOverride";
import fordStyles from "./ReportPreview-Ford.module.scss";
import lincolnStyles from "./ReportPreview-Lincoln.module.scss";
import { withTranslation } from "react-i18next";
import UpperCaseText from "../../../utils/UpperCaseText";
import { IS_FORD_BRAND } from "../../../utils/EmpUtil";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import EMPButton from "../../../shared/components/EMPButton/EMPButton";

let styles = fordStyles;
let isFordBrand = true;
let stylesOverride = fordStylesOverride;

// const StyledTableRow = withStyles({
//   root: {
//     height: "30px",
//   },
// })(TableRow);

// const TableCell = withStyles({
//   root: {
//     paddingLeft: "13px",
//     paddingRight: "13px",
//     paddingTop: "0px",
//     paddingBottom: "0px",
//     textAlign: "center",
//     border: "solid 1.5px #979797",
//     height: "30px",
//   },
// })(TableCell);

// const TableCell = withStyles({
//   root: {
//     paddingLeft: "5px",
//     paddingRight: "20px",
//     paddingTop: "0px",
//     paddingBottom: "0px",
//     textAlign: "left",
//     borderTop: "solid 1.5px #979797",
//     borderBottom: "solid 1.5px #979797",
//     borderRight: "solid 1.5px #979797",
//     width: "12%",
//   },
// })(TableCell);

const updateStyles = (props) => {
  isFordBrand = IS_FORD_BRAND(props.user.dealerBrand);
  stylesOverride = isFordBrand ? fordStylesOverride : lincolnStylesOverride;
  document.body.style.backgroundColor = isFordBrand ? "#ffffff" : "#f6f7f7";
  styles = isFordBrand ? fordStyles : lincolnStyles;
};

const OrdersPreview = (props) => {
  updateStyles(props);

  const dealerName =
    props.dealerInfo && props.dealerInfo[0]
      ? props.dealerInfo[0].dealerName + " - "
      : "";

  return (
    <div className={styles.tablePadding}>
      <div className={styles.info}>
        {props.t("fieldReporting.table.pleaseSelectReport")}
      </div>
      <div className={styles.dealerName}>
        {props.t("fieldReporting.table.ordersConversionDetails", {
          filterString: `${props.selectionTypes.model}, ${props.selectionTypes.modelYear}`,
        })}
      </div>
      <div className={styles.dealerInfo}>
        {isFordBrand
          ? UpperCaseText(dealerName) +
            UpperCaseText(props.selectionTypes.filterType) +
            props.selectionTypes.dateRange
          : UpperCaseText(dealerName) +
            props.selectionTypes.filterType +
            props.selectionTypes.dateRange}
      </div>
      <div className={styles.info}>
        <span>{props.t("fieldReporting.table.modelGroupingReportInfo")}</span>
        <EMPButton
          testId="downloadDealerReport"
          disabled={!props.renderPreview}
          onClick={() => props.downloadFieldReport()}
          variant="text"
          leftIcon={<CloudDownloadIcon />}
          submitButton
        >
          {props.t("fieldReporting.download")}
        </EMPButton>
      </div>
      <Table className={styles.table}>
        <TableHead>
          <TableRow>
            <TableCell style={stylesOverride.cellGreyBackground}>
              <div>{props.t("fieldReporting.table.description")}</div>
            </TableCell>
            <TableCell style={stylesOverride.cellGreyBackground}>
              <div>{props.t("fieldReporting.table.active")}</div>
            </TableCell>
            <TableCell style={stylesOverride.cellGreyBackground}>
              <div>{props.t("fieldReporting.table.canceled")}</div>
            </TableCell>
            <TableCell style={stylesOverride.cellGreyBackground}>
              <div>{props.t("fieldReporting.table.total")}</div>
            </TableCell>
            <TableCell style={stylesOverride.cellGreyBackground}>
              <div>{props.t("fieldReporting.table.ordersReqAttn")}</div>
            </TableCell>
            <TableCell style={stylesOverride.cellGreyBackground}>
              <div>{props.t("fieldReporting.table.dealerRejected")}</div>
            </TableCell>
            <TableCell style={stylesOverride.cellGreyBackground}>
              <div>{props.t("fieldReporting.table.ordersSubmitted")}</div>
            </TableCell>
            <TableCell style={stylesOverride.cellGreyBackground}>
              <div>{props.t("fieldReporting.table.depositsRefunded")}</div>
            </TableCell>
            <TableCell style={stylesOverride.cellGreyBackground}>
              <div>{props.t("fieldReporting.table.conversionRateToOrder")}</div>
            </TableCell>
            <TableCell style={stylesOverride.cellGreyBackground}>
              <div>{props.t("fieldReporting.table.unconvertedOrders")}</div>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {props.data !== null &&
            props.data.map((item, index) => {
              return (
                <TableRow key={index}>
                  <TableCell
                    style={
                      item.isTotal
                        ? stylesOverride.cellGreyBackgroundBold
                        : stylesOverride.cell
                    }
                  >
                    {item.isTotal
                      ? props.selectionTypes.totalType
                      : item.description}
                  </TableCell>
                  <TableCell
                    style={
                      item.isTotal
                        ? stylesOverride.cellGreyBackgroundBold
                        : stylesOverride.cell
                    }
                  >
                    {item.active}
                  </TableCell>
                  <TableCell
                    style={
                      item.isTotal
                        ? stylesOverride.cellGreyBackgroundBold
                        : stylesOverride.cell
                    }
                  >
                    {item.cancelled}
                  </TableCell>
                  <TableCell
                    style={
                      item.isTotal
                        ? stylesOverride.cellGreyBackgroundBold
                        : stylesOverride.cell
                    }
                  >
                    {item.total}
                  </TableCell>
                  <TableCell
                    style={
                      item.isTotal
                        ? stylesOverride.cellGreyBackgroundBold
                        : stylesOverride.cell
                    }
                  >
                    {item.ordersReqAttention}
                  </TableCell>
                  <TableCell
                    style={
                      item.isTotal
                        ? stylesOverride.cellGreyBackgroundBold
                        : stylesOverride.cell
                    }
                  >
                    {item.dealerRejected}
                  </TableCell>
                  <TableCell
                    style={
                      item.isTotal
                        ? stylesOverride.cellGreyBackgroundBold
                        : stylesOverride.cell
                    }
                  >
                    {item.ordersSubmitted}
                  </TableCell>
                  <TableCell
                    style={
                      item.isTotal
                        ? stylesOverride.cellGreyBackgroundBold
                        : stylesOverride.cell
                    }
                  >
                    {item.depositsRefunded}
                  </TableCell>
                  <TableCell
                    style={
                      item.isTotal
                        ? stylesOverride.cellGreyBackgroundBold
                        : stylesOverride.cell
                    }
                  >
                    {item.rtoRate}%
                  </TableCell>
                  <TableCell
                    style={
                      item.isTotal
                        ? stylesOverride.cellGreyBackgroundBold
                        : stylesOverride.cell
                    }
                  >
                    {item.unconvertedOrders}
                  </TableCell>
                </TableRow>
              );
            })}
        </TableBody>
      </Table>
    </div>
  );
};

export default withTranslation("emp")(OrdersPreview);
